export enum ChartTypes {
    Bar = "bar",
    Line = "line",
    Donut = "pie",
    Timeline = "timeline"
};